import {Component, OnInit} from '@angular/core';
import {Response} from '@angular/http';
import {Router} from '@angular/router';
import FileSaver from 'file-saver';

import {UserImportService} from './services/user-import.service';

@Component({
  selector: 'user-import',
  templateUrl: './user-import.component.html',
  styleUrls: ['./user-import.component.css'],
})
export class UserImportComponent {

  private file: File;

  constructor(private userImportService: UserImportService,
              private router: Router) { }

  public onFileChange(event: Event): void {
    this.file = (<HTMLInputElement> event.target).files[0];
  }

  public startImport(): void {
    this.userImportService.startImport(this.file)
      .subscribe((response: Response) => {
        this.router.navigateByUrl('/users');
    }, (error:Error) => {
      console.error("ERR %o", error);
      let msg: string = error.message;
      if (msg === undefined && error['_body'] !== undefined) {
        msg = error['_body'];
      }
      alert(msg);
    });
  }

  public getCSVSample(): void {
    this.userImportService.getSampleCSV()
      .subscribe((response: Blob) => {
        FileSaver.saveAs(response, 'UserImportSample.csv');
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/user/user-import/user-import.component.ts